module.exports = __webpack_public_path__ + "static/half-section-with-pattern-8722e0aec560b2ff7a3d77a09b244898.png";